import { type FilterConfig } from '../interfaces';

import { agentFilterConfigMultiple } from './default-config-multiple';

export const agentFilterConfigSingle: FilterConfig = {
  ...agentFilterConfigMultiple,
  multiple: false,
};
